let defaultParams = {};
let isInitialized = false;
let initializedMid = null;

const sanitize = (obj = {}) => {
  const clean = {};
  Object.entries(obj).forEach(([k, v]) => {
    if (v === undefined || v === null) return;
    if (typeof v === "object" || typeof v === "function") return;
    clean[k] = v;
  });
  return clean;
};

const GA_SCRIPT_HOST = "https://www.googletagmanager.com";
const GA_SCRIPT_PATH = "/gtag/js";

const ensureGtagStub = () => {
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
  }
};

const loadScript = (measurementId) => {
  return new Promise((resolve, reject) => {
    const src = `${GA_SCRIPT_HOST}${GA_SCRIPT_PATH}?id=${encodeURIComponent(
      measurementId
    )}`;

    // already exists
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) return resolve();

    const s = document.createElement("script");
    s.async = true;
    s.src = src;

    s.onload = () => resolve();
    s.onerror = (e) => reject(new Error(`Failed to load GA script: ${src}`));

    document.head.appendChild(s);
  });
};

export const initAnalytics = async (measurementId) => {
  if (!measurementId) {
    console.error("❌ Missing GA measurementId");
    return false;
  }

  // prevent re-init
  if (isInitialized) return true;

  // always create gtag stub first
  ensureGtagStub();

  try {
    // IMPORTANT: load from www.googletagmanager.com only
    await loadScript(measurementId);
  } catch (e) {
    console.error(e.message);
    // If script fails, GA cannot work client-side.
    return false;
  }

  // real gtag should exist now, but keep stub anyway
  ensureGtagStub();

  const isDev = process.env.NODE_ENV === "development";

  window.gtag("js", new Date());
  window.gtag("config", measurementId, {
    debug_mode: isDev, // Only enable debug mode in development
  });

  isInitialized = true;
  initializedMid = measurementId;

  return true;
};

export const setDefaultParams = (params) => {
  defaultParams = sanitize({ ...defaultParams, ...params });
};

export const logAnalyticEvent = (eventName, data = {}) => {
  if (!isInitialized || !window.gtag) {
    console.warn("GA not initialized, event skipped:", eventName);
    return;
  }
  const payload = sanitize({ ...defaultParams, ...data });

  const isDev = process.env.NODE_ENV === "development";

  window.gtag("event", eventName, { ...payload, debug_mode: isDev });
};
